// Module registry — describes what each module type does
export const MODULES = [
  { id: "repair", name: "Repair Guide", icon: "🔧", desc: "Step-by-step FSM-guided repairs", color: "#f59e0b" },
  { id: "diagnostics", name: "Diagnostics", icon: "⚡", desc: "OBD2 + troubleshooting trees", color: "#3b82f6" },
  { id: "troubleshoot", name: "Troubleshoot", icon: "🔎", desc: "AI-flattened diagnostic paths from FSM", color: "#e879f9" },
  { id: "alignment", name: "Alignment", icon: "◎", desc: "Camera-based wheel alignment", color: "#4ade80" },
  { id: "maintenance", name: "Maintenance", icon: "🛢️", desc: "Service intervals & fluid tracking", color: "#8b5cf6" },
  { id: "obd_live", name: "OBD2 Live", icon: "📊", desc: "Real-time PID monitoring & logging", color: "#06b6d4" },
  { id: "parts", name: "Parts Bin", icon: "📦", desc: "Inventory of parts on hand", color: "#f87171" },
];

// NICOclub FSM section codes for the FSM Library demo
export const LEAF_2013_FSM_SECTIONS = [
  { code: "FWD", name: "Intro - Table of Contents" },
  { code: "ACC", name: "Accelerator Control System" },
  { code: "AVN", name: "Audio, Visual and Navigation" },
  { code: "BCS", name: "Body Control System" },
  { code: "BR", name: "Brake System" },
  { code: "BRC", name: "Brake Control System" },
  { code: "BRM", name: "Body Repair Manual" },
  { code: "CCS", name: "Cruise Control System" },
  { code: "CHG", name: "Charging System" },
  { code: "DEF", name: "Defogger" },
  { code: "DLK", name: "Door and Lock" },
  { code: "EVB", name: "EV Battery" },
  { code: "EVC", name: "EV Control" },
  { code: "EXL", name: "Exterior Lighting" },
  { code: "EXT", name: "Exterior" },
  { code: "FAX", name: "Front Axle" },
  { code: "FSU", name: "Front Suspension" },
  { code: "GW", name: "Glass and Window System" },
  { code: "HA", name: "Heater and A/C System" },
  { code: "HAC", name: "Heater and A/C Control" },
  { code: "HRN", name: "Horn" },
  { code: "ILL", name: "Interior Lighting" },
  { code: "INT", name: "Interior" },
  { code: "IP", name: "Instrument Panel" },
  { code: "LAN", name: "LAN System" },
  { code: "MA", name: "Maintenance" },
  { code: "MIR", name: "Mirrors" },
  { code: "MWI", name: "Meter, Warning Lamp and Indicator" },
  { code: "PB", name: "Parking Brake" },
  { code: "PCS", name: "Power Control System" },
  { code: "PG", name: "Power Supply, Ground and Circuits" },
  { code: "PWC", name: "Power Window Control" },
  { code: "PWO", name: "Power Outlet" },
  { code: "RAX", name: "Rear Axle" },
  { code: "RSU", name: "Rear Suspension" },
  { code: "SB", name: "Seat Belt" },
  { code: "SE", name: "Seat" },
  { code: "SEC", name: "Security Control System" },
  { code: "SRS", name: "SRS Airbag" },
  { code: "SRSC", name: "SRS Airbag Control" },
  { code: "ST", name: "Steering System" },
  { code: "STC", name: "Steering Control System" },
  { code: "TM", name: "Transaxle and Transmission" },
  { code: "VTL", name: "Ventilation System" },
  { code: "WCS", name: "Warning Chime System" },
  { code: "WT", name: "Road Wheels and Tires" },
  { code: "WW", name: "Wiper and Washer" },
];
